import React from "react";
import { Fragment } from "react";

type Props = {
  label?: string;
  period?: string;
};

const Badge = ({ label, period }: Props) => {
  if (
    period?.toString()?.includes("undefined") ||
    period?.toString().includes("null")
  )
    return null;

  return (
    <Fragment>
      {label ? (
        <div className="relative inline-flex w-fit items-center justify-center rounded-lg border border-border px-3 text-xs text-brand-navy">
          <p className="w-fit py-0.5">{label || ""}</p>
          {!!period && (
            <p className="absolute -right-3 -top-2 z-[2] rounded-md bg-brand-orange px-1 text-[0.625rem] font-semibold leading-[1.5] tabular-nums !text-white">
              {`${period}yr${+period > 1 ? "s" : ""}` || ""}
            </p>
          )}
        </div>
      ) : null}
    </Fragment>
  );
};

export default Badge;
